module.exports = __webpack_public_path__ + "img/home-pic-13.35cffbd4.jpg";